var render = function () {
  var _obj
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.hasIncident
    ? _c("div", [
        _c(
          "em",
          {
            staticClass: "d-block px-4 py-1 text-center",
            class:
              ((_obj = {}),
              (_obj[_vm.bannerStyleClasses] = true),
              (_obj["mb-3"] = !_vm.noSpacing),
              _obj),
            staticStyle: { "border-radius": "3px" },
          },
          [_vm._v(_vm._s(_vm.incident.description))]
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }